<template>
    <section class="blockElement subscriptionPlanSteps vh-100 overflow-auto space">
        <!-- <Header /> -->
        <div class="container">
            <div class="row pamentCalc align-items-center justify-content-center">
                <div class="col-12 col-md-4 text-center">
                    <div class="pt-0 genrateMessage mb-4 pb-1">
                        <img height="100" width="100" class="animate d-block mx-auto mb-4" :src="`${static_vars.imagePath}/assets/images/success14789.png`" :alt="$t('complete_registration.text4')" />
                        <h3 class="my-3 clash">{{$t('complete_registration.text1')}}</h3>
                    </div>
                    <div class="w-100">
                        <a class="grd_btn full_size mb-3" href="javascript:void(0)" @click="submit()">{{$t('complete_registration.text2')}}</a>
                        <a class="primary medium" :href="`${static_vars.domainURL}dashboard/?token=${store.user?.access_token}&refresh_token=${store.user?.refresh_token}`">{{$t('complete_registration.text3')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { useMainStore } from "@/store";
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    methods: {
        submit(){
            this.$router.replace('/add-trading-account')
        }
    },
    created(){
        this.store.getFlavourData({},false)
        this.store.getUserAccountsList({},false)
    }
}

</script>